import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ChakraProvider } from '@chakra-ui/react';
import { AppRoutes } from './routes/AppRoutes';
import { LoadingSpinner } from './components/common/LoadingSpinner';
import { SettingsInitializer } from './components/common/SettingsInitializer';
import { themes } from './theme';
import { AuthProvider } from './contexts/AuthContext'
import { ApiProvider } from './contexts/ApiContext'
import { ThemeProvider } from './contexts/ThemeContext'
import { UserProfileProvider } from '@/contexts/userprofile/UserProfileContext';

// Theme wrapper component that reacts to theme changes
const ThemeWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentTheme, setCurrentTheme] = React.useState(themes.ocean);

  React.useEffect(() => {
    // Get initial theme variant from localStorage
    const storedVariant = localStorage.getItem('theme-variant') as 'ocean' | 'orchid' | 'neon' | 'business';
    if (storedVariant && themes[storedVariant]) {
      setCurrentTheme(themes[storedVariant]);
    }

    // Listen for theme changes
    const handleThemeChange = (event: CustomEvent) => {
      const { variant } = event.detail;
      if (themes[variant as keyof typeof themes]) {
        setCurrentTheme(themes[variant as keyof typeof themes]);
      }
    };

    window.addEventListener('theme-change', handleThemeChange as EventListener);
    
    return () => {
      window.removeEventListener('theme-change', handleThemeChange as EventListener);
    };
  }, []);

  return (
    <ChakraProvider theme={currentTheme}>
        {children}
    </ChakraProvider>
  );
};

function App() {
  console.log('🚀 [App] Application starting, version: 1.0.1-websocket-debug');
  
  return (
    <ThemeWrapper>
      <ThemeProvider>
        <AuthProvider>
          <ApiProvider>
            <UserProfileProvider>
              <BrowserRouter>
                  <SettingsInitializer>
                    <Suspense fallback={<LoadingSpinner />}>
                      <AppRoutes />
                    </Suspense>
                  </SettingsInitializer>
              </BrowserRouter>
            </UserProfileProvider>
          </ApiProvider>
        </AuthProvider>
      </ThemeProvider>
    </ThemeWrapper>
  );
}

export default App; 